<template>
  <b-container class="fieldsmanagement">
    <b-row>
      <b-col cols="12" md="12" lg="10" offset-lg="1">
        <h2>Field Mapping</h2>
        <b-button variant="primary" class="mx-1 my-1" @click="showAddField">Create New Field Mapping</b-button>
        <b-button variant="primary" class="mx-1 my-1" @click="refreshFields">Refresh</b-button>
        <b-tabs content-class="mt-3">
          <b-tab title="Mathematics">
            <b-table
              striped
              small
              hover
              :fields="jasperFieldFields"
              :items="mathematicsFieldsList"
              :sort-by.sync="fieldsSortBy"
              :tbody-tr-class="rowClass"
            >
              <template #cell(is_optional)="data">
                <b-icon v-if="data.item.is_optional" icon="check-square-fill" variant="success"></b-icon>
                <b-icon v-else icon="x-square-fill" variant="secondary"></b-icon>
              </template>
              <template #cell(include_in_update)="data">
                <b-icon v-if="data.item.include_in_update" icon="check-square-fill" variant="success"></b-icon>
                <b-icon v-else icon="x-square-fill" variant="secondary"></b-icon>
              </template>
              <template #cell(allow_empty)="data">
                <b-icon v-if="data.item.allow_empty" icon="check-square-fill" variant="success"></b-icon>
                <b-icon v-else icon="x-square-fill" variant="secondary"></b-icon>
              </template>
              <template #cell(is_unique)="data">
                <b-icon v-if="data.item.is_unique" icon="check-square-fill" variant="success"></b-icon>
                <b-icon v-else icon="x-square-fill" variant="secondary"></b-icon>
              </template>
              <template #cell(actions)="data">
                <b-button
                  class="mx-2"
                  size="sm"
                  @click="showDeleteField(data.item.source_name, 'mathematics')"
                  variant="outline-danger"
                  v-if="!data.item.is_locked"
                >
                  <b-icon icon="trash"></b-icon>
                </b-button>
                <b-icon v-else icon="shield-lock-fill"></b-icon>
              </template>
            </b-table>
          </b-tab>
          <b-tab title="MoCos">
            <b-table
              striped
              small
              hover
              :fields="jasperFieldFields"
              :items="materialFieldsList"
              :sort-by.sync="fieldsSortBy"
              :tbody-tr-class="rowClass"
            >
              <template #cell(is_optional)="data">
                <b-icon v-if="data.item.is_optional" icon="check-square-fill" variant="success"></b-icon>
                <b-icon v-else icon="x-square-fill" variant="secondary"></b-icon>
              </template>
              <template #cell(include_in_update)="data">
                <b-icon v-if="data.item.include_in_update" icon="check-square-fill" variant="success"></b-icon>
                <b-icon v-else icon="x-square-fill" variant="secondary"></b-icon>
              </template>
              <template #cell(allow_empty)="data">
                <b-icon v-if="data.item.allow_empty" icon="check-square-fill" variant="success"></b-icon>
                <b-icon v-else icon="x-square-fill" variant="secondary"></b-icon>
              </template>
              <template #cell(is_unique)="data">
                <b-icon v-if="data.item.is_unique" icon="check-square-fill" variant="success"></b-icon>
                <b-icon v-else icon="x-square-fill" variant="secondary"></b-icon>
              </template>
              <template #cell(actions)="data">
                <b-button
                  class="mx-2"
                  size="sm"
                  @click="showDeleteField(data.item.source_name, 'material')"
                  variant="outline-danger"
                  v-if="!data.item.is_locked"
                >
                  <b-icon icon="trash"></b-icon>
                </b-button>
                <b-icon v-else icon="shield-lock-fill"></b-icon>
              </template>
            </b-table>
          </b-tab>
          <b-tab title="VTO RTR">
            <b-table
              striped
              small
              hover
              :fields="jasperFieldFields"
              :items="vtoFieldsList"
              :sort-by.sync="fieldsSortBy"
              :tbody-tr-class="rowClass"
            >
              <template #cell(is_optional)="data">
                <b-icon v-if="data.item.is_optional" icon="check-square-fill" variant="success"></b-icon>
                <b-icon v-else icon="x-square-fill" variant="secondary"></b-icon>
              </template>
              <template #cell(include_in_update)="data">
                <b-icon v-if="data.item.include_in_update" icon="check-square-fill" variant="success"></b-icon>
                <b-icon v-else icon="x-square-fill" variant="secondary"></b-icon>
              </template>
              <template #cell(allow_empty)="data">
                <b-icon v-if="data.item.allow_empty" icon="check-square-fill" variant="success"></b-icon>
                <b-icon v-else icon="x-square-fill" variant="secondary"></b-icon>
              </template>
              <template #cell(is_unique)="data">
                <b-icon v-if="data.item.is_unique" icon="check-square-fill" variant="success"></b-icon>
                <b-icon v-else icon="x-square-fill" variant="secondary"></b-icon>
              </template>
              <template #cell(actions)="data">
                <b-button
                  class="mx-2"
                  size="sm"
                  @click="showDeleteField(data.item.source_name, 'vto')"
                  variant="outline-danger"
                  v-if="!data.item.is_locked"
                >
                  <b-icon icon="trash"></b-icon>
                </b-button>
                <b-icon v-else icon="shield-lock-fill"></b-icon>
              </template>
            </b-table>
          </b-tab>
          <b-tab title="Custom">
            <b-table
              striped
              small
              hover
              :fields="jasperFieldFields"
              :items="ocpFieldsList"
              :sort-by.sync="fieldsSortBy"
              :tbody-tr-class="rowClass"
            >
              <template #cell(is_optional)="data">
                <b-icon v-if="data.item.is_optional" icon="check-square-fill" variant="success"></b-icon>
                <b-icon v-else icon="x-square-fill" variant="secondary"></b-icon>
              </template>
              <template #cell(include_in_update)="data">
                <b-icon v-if="data.item.include_in_update" icon="check-square-fill" variant="success"></b-icon>
                <b-icon v-else icon="x-square-fill" variant="secondary"></b-icon>
              </template>
              <template #cell(allow_empty)="data">
                <b-icon v-if="data.item.allow_empty" icon="check-square-fill" variant="success"></b-icon>
                <b-icon v-else icon="x-square-fill" variant="secondary"></b-icon>
              </template>
              <template #cell(is_unique)="data">
                <b-icon v-if="data.item.is_unique" icon="check-square-fill" variant="success"></b-icon>
                <b-icon v-else icon="x-square-fill" variant="secondary"></b-icon>
              </template>
              <template #cell(actions)="data">
                <b-button
                  class="mx-2"
                  size="sm"
                  @click="showDeleteField(data.item.source_name, 'ocp')"
                  variant="outline-danger"
                  v-if="!data.item.is_locked"
                >
                  <b-icon icon="trash"></b-icon>
                </b-button>
                <b-icon v-else icon="shield-lock-fill"></b-icon>
              </template>
            </b-table>
          </b-tab>
          <b-tab title="SGH">
            <b-table
              striped
              small
              hover
              :fields="jasperFieldFields"
              :items="sghFieldsList"
              :sort-by.sync="fieldsSortBy"
              :tbody-tr-class="rowClass"
            >
              <template #cell(is_optional)="data">
                <b-icon v-if="data.item.is_optional" icon="check-square-fill" variant="success"></b-icon>
                <b-icon v-else icon="x-square-fill" variant="secondary"></b-icon>
              </template>
              <template #cell(include_in_update)="data">
                <b-icon v-if="data.item.include_in_update" icon="check-square-fill" variant="success"></b-icon>
                <b-icon v-else icon="x-square-fill" variant="secondary"></b-icon>
              </template>
              <template #cell(allow_empty)="data">
                <b-icon v-if="data.item.allow_empty" icon="check-square-fill" variant="success"></b-icon>
                <b-icon v-else icon="x-square-fill" variant="secondary"></b-icon>
              </template>
              <template #cell(is_unique)="data">
                <b-icon v-if="data.item.is_unique" icon="check-square-fill" variant="success"></b-icon>
                <b-icon v-else icon="x-square-fill" variant="secondary"></b-icon>
              </template>
              <template #cell(actions)="data">
                <b-button
                  class="mx-2"
                  size="sm"
                  @click="showDeleteField(data.item.source_name, 'sgh')"
                  variant="outline-danger"
                  v-if="!data.item.is_locked"
                >
                  <b-icon icon="trash"></b-icon>
                </b-button>
                <b-icon v-else icon="shield-lock-fill"></b-icon>
              </template>
            </b-table>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
    <b-modal
      ref="newFieldModal"
      title="Create new field mapping"
      hide-header-close
      @ok="addFieldMapping"
      :ok-disabled="!newFieldFormValid"
    >
      <label>Ingest Type:</label>
      <b-form-select v-model="newFieldIngestType" :options="newFieldIngestTypeOptions" :state="newFieldIngestTypeState"></b-form-select>
      <b-form-group
        label="Source name:"
        label-for="newFieldSourceName"
        :state="newFieldSourceNameState"
        :invalid-feedback="defaultFeedback"
        description="Header column name in the Excel File"
      >
        <b-form-input id="newFieldSourceName" v-model="newFieldSourceName"></b-form-input>
      </b-form-group>
      <b-form-group
        label="Shotgrid name:"
        label-for="newFieldShotgridName"
        :state="newFieldShotgridNameState"
        :invalid-feedback="defaultFeedback"
        description="Field code on Shotgrid. This is usually 'sg_...'. For example: 'sg_wt'."
      >
        <b-form-input id="newFieldShotgridName" v-model="newFieldShotgridName"></b-form-input>
      </b-form-group>
      <b-form-group
        label="Data type:"
        label-for="newFieldDataType"
        :state="newFieldDataTypeState"
        :invalid-feedback="defaultFeedback"
        description="Expected data type for the field. (str, int, float, bool, ...)"
      >
        <b-form-input id="newFieldDataType" v-model="newFieldDataType"></b-form-input>
      </b-form-group>
      <b-form-checkbox id="newFieldIsOptional" v-model="newFieldIsOptional" switch
        >Is Optional. When ticked, the field does not necessarily need to exist in the ingest excel.</b-form-checkbox
      >
      <!-- 
      Removed the lock option on new fields as part of https://redmine.pixel-nexus.com/issues/6168. 
      All user-created fields are unlocked, the only locked fields are those that are hard-coded in the backend. 
      -->
      <!-- <b-form-checkbox id="newFieldIsLocked" v-model="newFieldIsLocked" switch
        >Is locked. When ticked, the field is locked and cannot be changed later.</b-form-checkbox
      > -->
      <b-form-checkbox id="newFieldAllowEmpty" v-model="newFieldAllowEmpty" switch
        >Allow empty values. When ticked, the values for this field may be empty in the ingest excel.</b-form-checkbox
      >
      <b-form-checkbox id="newFieldIsUnique" v-model="newFieldIsUnique" switch
        >Is Unique. When ticked, the values in this field have to be unique, no duplicates allowed.</b-form-checkbox
      >
      <ul>
        <li v-for="line in newRuleValidationMessages" :key="line">
          {{ line }}
        </li>
      </ul>
    </b-modal>
    <b-modal ref="deleteFieldModal" title="Disable field?" hide-header-close @ok="disableRule">
      <template #modal-ok>Confirm</template>
      <label>Ingest Type:</label>
      <b-form-input v-model="deleteFieldEntity" disabled></b-form-input>
      <label>Field Source Name:</label>
      <b-form-input v-model="deleteFieldSourceName" disabled></b-form-input>
    </b-modal>
  </b-container>
</template>
<script>
import { defaultToastBody, defaultToastConfig } from '@/util'

const _STAGE_STATES = {
  WAITING: 10,
  IN_PROGRESS: 20,
  FINISHED: 30,
  ERROR: -100,
}

const _resetSubmitInfo = () => {
  return {
    finished: false,
    resultText: '',
    resultLines: [],
    stages: {
      UPLOAD: {
        index: 0,
        state: _STAGE_STATES.WAITING,
        display_text: 'Uploading file',
        progress: 0,
        progressTotal: 100,
      },
      WAIT_RESP: {
        index: 1,
        state: _STAGE_STATES.WAITING,
        display_text: 'Waiting for server processing',
        progress: 0,
        progressTotal: 100,
      },
    },
  }
}

export default {
  name: 'JasperFieldManagement',
  data: function () {
    return {
      STAGE_STATES: _STAGE_STATES,
      newFieldSourceName: '',
      newFieldShotgridName: 'sg_',
      newFieldDataType: 'str',
      newFieldIsOptional: true,
      newFieldIsLocked: false,
      newFieldAllowEmpty: true,
      newFieldIsUnique: true,
      newRuleValidationMessages: [],
      newRuleValidationLoading: false,
      submitInfo: _resetSubmitInfo(),
      deleteFieldId: null,
      deleteFieldSourceName: '',
      deleteFieldEntity: '',
      jasperFieldFields: [
        { key: 'source_name', sortable: true },
        { key: 'shotgrid_name', sortable: true },
        { key: 'is_optional' },
        { key: 'data_type' },
        { key: 'allow_empty' },
        { key: 'is_unique' },
        { key: 'actions' },
      ],
      fieldsSortBy: 'source_name',
      newFieldIngestType: null,
      // newFieldIngestTypeOptions: [
      //   { value: null, text: 'Please select an ingest type.', disabled: true },
      //   { value: 'material', text: 'Material' },
      //   { value: 'mathematics', text: 'Mathematics' },
      //   { value: 'vto', text: 'VTO' },
      // ],
    }
  },
  computed: {
    mathematicsFieldsList() {
      return this.$store.state.ingestFields.mathematics
    },
    materialFieldsList() {
      return this.$store.state.ingestFields.material
    },
    vtoFieldsList() {
      return this.$store.state.ingestFields.vto
    },
    newFieldIngestTypeOptions() {
      return this.$store.state.categoryOptions
    },
    ocpFieldsList() {
      return this.$store.state.ingestFields.ocp
    },
    sghFieldsList() {
      return this.$store.state.ingestFields.sgh
    },
    newFieldSourceNameState() {
      return this.newFieldSourceName.length > 0
    },
    newFieldShotgridNameState() {
      return this.newFieldShotgridName.length > 0
    },
    newFieldIngestTypeState() {
      return this.newFieldIngestType != null
    },
    newFieldDataTypeState() {
      return this.newFieldDataType.length > 0
    },
    defaultFeedback() {
      return 'Required'
    },
    newFieldFormValid: function () {
      return this.newFieldSourceNameState && this.newFieldShotgridNameState && this.newFieldDataTypeState && this.newFieldIngestTypeState
    },
  },
  methods: {
    rowClass: function (ruleObj, type) {
      if (!ruleObj || type !== 'row') {
        return
      } // Skip
      //if (ruleObj.is_locked) return "table-secondary";
    },
    showAddField: function () {
      this.newFieldSourceName = ''
      this.newFieldShotgridName = 'sg_'
      this.newFieldAllowSGUndefined = false
      this.newFieldIngestType = null
      this.$refs['newFieldModal'].show()
    },
    addFieldMapping: function () {
      let payload = {
        ingest_type: this.newFieldIngestType,
        source_name: this.newFieldSourceName,
        shotgrid_name: this.newFieldShotgridName,
        is_optional: this.newFieldIsOptional,
        is_locked: this.newFieldIsLocked,
        data_type: this.newFieldDataType,
        allow_empty: this.newFieldAllowEmpty,
        is_unique: this.newFieldIsUnique,
      }
      this.$store
        .dispatch('createFieldMapping', payload)
        .then((res) => {
          let toastConfig = defaultToastConfig()
          toastConfig.title = 'New field mapping created.'
          toastConfig.variant = 'success'
          this.$bvToast.toast(`Created field ID: ${res.id}`, toastConfig)
          this.refreshFields()
        })
        .catch((err) => {
          this.$bvToast.toast(defaultToastBody(err), defaultToastConfig(err))
        })
    },
    closeSubmitModal() {
      this.$refs['csvSubmitModal'].hide()
    },
    refreshFields: function () {
      this.$store
        // TODO: Set loading state to true
        .dispatch('getIngestFields', "material")
        .then(() => {
          let toastConfig = defaultToastConfig()
          toastConfig.title = 'Data loaded'
          toastConfig.variant = 'success'
          toastConfig.autoHideDelay = 800 // Quicker message
          this.$bvToast.toast(`Material Field definitions loaded from server successfully.`, toastConfig)
        })
        .catch((err) => {
          this.$bvToast.toast(defaultToastBody(err), defaultToastConfig(err))
        })

      this.$store
        // TODO: Set loading state to true
        .dispatch('getIngestFields', "mathematics")
        .then(() => {
          let toastConfig = defaultToastConfig()
          toastConfig.title = 'Data loaded'
          toastConfig.variant = 'success'
          toastConfig.autoHideDelay = 800 // Quicker message
          this.$bvToast.toast(`Mathematics Field definitions loaded from server successfully.`, toastConfig)
        })
        .catch((err) => {
          this.$bvToast.toast(defaultToastBody(err), defaultToastConfig(err))
        })

      this.$store
        // TODO: Set loading state to true
        .dispatch('getIngestFields', "vto")
        .then(() => {
          let toastConfig = defaultToastConfig()
          toastConfig.title = 'Data loaded'
          toastConfig.variant = 'success'
          toastConfig.autoHideDelay = 800 // Quicker message
          this.$bvToast.toast(`VTO Field definitions loaded from server successfully.`, toastConfig)
        })
        .catch((err) => {
          this.$bvToast.toast(defaultToastBody(err), defaultToastConfig(err))
        })
      
        this.$store
        // TODO: Set loading state to true
        .dispatch('getIngestFields', "ocp")
        .then(() => {
          let toastConfig = defaultToastConfig()
          toastConfig.title = 'Data loaded'
          toastConfig.variant = 'success'
          toastConfig.autoHideDelay = 800 // Quicker message
          this.$bvToast.toast(`OCP Field definitions loaded from server successfully.`, toastConfig)
        })
        .catch((err) => {
          this.$bvToast.toast(defaultToastBody(err), defaultToastConfig(err))
        })
        this.$store
        // TODO: Set loading state to true
        .dispatch('getIngestFields', "sgh")
        .then(() => {
          let toastConfig = defaultToastConfig()
          toastConfig.title = 'Data loaded'
          toastConfig.variant = 'success'
          toastConfig.autoHideDelay = 800 // Quicker message
          this.$bvToast.toast(`SGH Field definitions loaded from server successfully.`, toastConfig)
        })
        .catch((err) => {
          this.$bvToast.toast(defaultToastBody(err), defaultToastConfig(err))
        })
    },
    showDeleteField: function (sourceName, entity) {
      this.deleteFieldSourceName = sourceName
      this.deleteFieldEntity = entity
      this.$refs['deleteFieldModal'].show()
    },
    disableRule: function () {
      let payload = {
        sourceName: this.deleteFieldSourceName,
        entity: this.deleteFieldEntity
      }
      this.$store
        .dispatch('deleteFieldMapping', payload)
        .then(() => {
          this.refreshFields()
        })
        .catch((err) => {
          this.$bvToast.toast(defaultToastBody(err), defaultToastConfig(err))
        })
    },
  },
  components: {},
  created() {},
  mounted() {
    if (this.$store.state.ingestFields.mathematics.length === 0) {
      this.refreshFields()
    }
    // if (this.dateTimeFormatsText.length === 0) {
    //   this.getDateTimeFormats();
    // }
  },
}
</script>
